module.exports = __webpack_public_path__ + "img/2_152.3f9ceecd.png";